import styled from "styled-components";
import { ReactComponent as CheckSVG } from 'assets/icons/check.svg';


export const Container = styled.div`
  border: ${({ theme, $isOpen }) => $isOpen
    ? `1px solid ${theme.lang.main}`
    : '1px solid transparent'
  };
  border-radius: 8px;
  width: 100%;
  height: ${({ $isOpen }) => $isOpen ? '128px' : '38px'};
  transition: all 200ms;
  overflow: hidden;
  background-color: transparent;
`


export const Option = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-radius: 8px;
  transition: opacity 200ms;
  cursor: pointer;
  width: 100%;
  border: none;

  background-color: ${({ theme, $isSelected }) => $isSelected
    ? theme.lang.main
    : 'transparent'
  };

  opacity: ${({ $isSelected }) => $isSelected
    ? 1
    : 0.6
  };

  :hover {
    opacity: 1
  }
`


export const Check = styled(CheckSVG)`
  height: 20px;
  color: ${({ theme }) => theme.text.headline};
`
